// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GenericPolicyIcon = createSvgIcon(
  <svg xmlSpace="preserve" fill="currentColor" viewBox="0 0 24 24">
    <linearGradient
      id="generic-policy_svga"
      x1={3.79}
      x2={18.97}
      y1={3.99}
      y2={16.82}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#9147FF" />
      <stop offset={1} stopColor="#4C35E8" />
    </linearGradient>
    <path
      fill="url(#generic-policy_svga)"
      d="M12 1 3 5v6c0 5.5 3.8 10.7 9 12 2.3-.6 4.3-1.9 5.9-3.7l-3.1-3.1a5 5 0 0 1-6.3-7.7c1.9-2 5.1-2 7.1 0a5 5 0 0 1 .6 6.3l2.9 2.9c1.2-2 1.9-4.3 1.9-6.7V5z"
    />
    <linearGradient
      id="generic-policy_svgb"
      x1={3.27}
      x2={18.44}
      y1={4.62}
      y2={17.44}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#9147FF" />
      <stop offset={1} stopColor="#4C35E8" />
    </linearGradient>
    <circle cx={12} cy={12} r={3} fill="url(#generic-policy_svgb)" />
  </svg>,
  "GenericPolicy",
);
export default GenericPolicyIcon;
